import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatSelectModule } from '@angular/material/select';
import { FabricanteService } from '../../../shared/services/apis/repositorio-tintas/fabricante.service';
import { ListaFabricanteResponse } from '../../../shared/services/responses/repositorio-tintas/lista-fabricante.response';
import { DatePipe } from '@angular/common';
import { Fabricante } from '../../../shared/services/models/repositorio-tintas/fabricante.model';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-fabricante-lista',
  imports: [
    MenuComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    ReactiveFormsModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    FormsModule,
    TemPermissaoDirective,
  ],
  providers: [DatePipe],
  templateUrl: './fabricante-lista.component.html',
  styleUrl: './fabricante-lista.component.css',
})
export class FabricanteListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private fabricanteService: FabricanteService,
    private alertService: AlertService,
    private datePipe: DatePipe
  ) {
    this.moduloEnum = ModuloEnum.Tintas;
    this.funcionalidadeEnum = FuncionalidadeEnum.Tintas_Fabricante;
  }
  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaFabricanteResponse: ListaFabricanteResponse | undefined;
  public displayedColumns: string[] = [
    'idFabricante',
    'nomeFabricante',
    'versao',
    'status',
    'datetimeInclusao',
    'action-edit',
  ];
  public _dataSource = new MatTableDataSource<Fabricante>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;

  async ngOnInit(): Promise<void> {
    this.model = this.formBuilder.group({
      nomeFabricante: [''],
    });

    await this.pesquisar();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;
    const nomeFabricante: string = this.model.get('nomeFabricante')?.value;

    this.fabricanteService.listaFabricante(nomeFabricante, this._paginaAtual).subscribe({
      next: (fabricanteResponse: ListaFabricanteResponse) => {
        this._isLoading = false;
        if (fabricanteResponse.isError) {
          this.alertService.show('Erro', fabricanteResponse.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaFabricanteResponse) {
          this._listaFabricanteResponse = fabricanteResponse;
          this._ultimaPagina = false;
        } else if (fabricanteResponse.listaFabricante?.length > 0) {
          this._listaFabricanteResponse.listaFabricante.push(...fabricanteResponse.listaFabricante);
          this._ultimaPagina = false;
        }
        this._dataSource.data = this._listaFabricanteResponse.listaFabricante;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaFabricanteResponse = undefined;
    this.pesquisar();
  }

  formatDatetimeInclusao(element: any): string {
    return (
      this.datePipe.transform(
        new Date(element.datetimeInclusao + 'Z'),
        'dd/MM/yyyy HH:mm:ss',
        'America/Sao_Paulo'
      ) || ''
    );
  }
}
